import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-oregon-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./oregon-state-form.component.html",
  styleUrl: "./oregon-state-form.component.scss",
})
export class OregonStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
